import ContentLoader from "react-content-loader";

type ItemProps = {
  width?: string;
};

type ModalIndividualItemLoaderProps = {
  loading: boolean;
  count?: number;
  width?: string;
};

const Item = (props: ItemProps) => {
  return (
    <ContentLoader
      style={{
        backgroundColor: "#FFFFFF",
        marginBottom: "10px",
        borderBottom: "1px solid #f9f8f6",
      }}
      // viewBox="0 0 0 0"
      height={58}
      width={props.width ? props.width : "98%"}
    >
      <rect x="5" y="18" rx="5" ry="5" width="18" height="18" />
      <circle cx="46" cy="27" r="20" />
      <rect x="76" y="3" rx="8" ry="8" width="120" height="15" />
      <rect x="76" y="21" rx="8" ry="8" width="130" height="13" />
      <rect x="76" y="38" rx="8" ry="8" width="150" height="14" />
    </ContentLoader>
  );
};

const ModalIndividualItemLoader = (props: ModalIndividualItemLoaderProps) => {
  const { loading, width, count } = props;
  return loading ? (
    <>
      {Array.from(Array(count).keys()).map((index) => (
        <Item key={index} width={width} />
      ))}
    </>
  ) : null;
};

ModalIndividualItemLoader.defaultProps = {
  loading: false,
  count: 5,
};

export default ModalIndividualItemLoader;
